import { render, staticRenderFns } from "./MessageCommentLocator.vue?vue&type=template&id=2a9f0a42&scoped=true"
import script from "./MessageCommentLocator.vue?vue&type=script&lang=js"
export * from "./MessageCommentLocator.vue?vue&type=script&lang=js"
import style0 from "./MessageCommentLocator.vue?vue&type=style&index=0&id=2a9f0a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9f0a42",
  null
  
)

export default component.exports